import { SxProps } from "@mui/material";

import { TableSortData } from "../../../types/table";

export function generateTableHeaderEntriesWithSorting<TableData>({
  entries,
  tableSortData,
}: {
  entries: {
    fieldName: keyof TableData;
    label: string;
    isSortable?: boolean;
    sx?: SxProps;
    isHidden?: boolean;
    isVisible?: boolean;
  }[];
  tableSortData?: TableSortData<TableData>;
}) {
  return entries.map(
    ({ fieldName, label, sx, isSortable = true, isHidden, isVisible }) => ({
      fieldName,
      label,
      sx,
      isSortable,
      isHidden,
      isVisible,
      sortDirection:
        tableSortData?.key === fieldName ? tableSortData.direction : null,
    })
  );
}
